import HTTP from '../HTTP';

const PANNEAUX_NUMERIQUES_URL = 'PanneauxNumeriques';

export async function browsePanneaux(location, rayon, dateStart, dateEnd, proposableLc, codeFace) {
  let propoLc = '';
  if (proposableLc === '1') {
    propoLc = '&proposableLc=true';
  }
  if (proposableLc === '0') {
    propoLc = '&proposableLc=false';
  }
  if (codeFace === '') {
    try {
      const response = await HTTP.get(PANNEAUX_NUMERIQUES_URL + '?latitude=' + location.lat
                                                              + '&longitude=' + location.lng
                                                              + '&rayon=' + rayon
                                                              + '&datedebut=' + dateStart
                                                              + '&datefin=' + dateEnd
                                                              + propoLc);
      return response;
    } catch (e) {
      throw e;
    }
  } else {
    try {
      const response = await HTTP.get(PANNEAUX_NUMERIQUES_URL + '?latitude=' + (location === null ? 0 : location.lat)
                                                              + '&longitude=' + (location === null ? 0 : location.lng)
                                                              + '&rayon=' + rayon
                                                              + '&datedebut=' + dateStart
                                                              + '&datefin=' + dateEnd
                                                              + '&codeFace=' + codeFace
                                                              + propoLc);
      return response;
    } catch (e) {
      throw e;
    }
  }
}

export async function other() {
  try {
    const response = await HTTP.get(PANNEAUX_NUMERIQUES_URL);
    return response;
  } catch (e) {
    throw e;
  }
}
export async function getPanneauxPoints(locations, rayon, dateStart, dateEnd,
  proposableLc, codeFace) {
  try {
    if (!locations.length) {
      return [];
    }
    const requests = [];
    locations.forEach(location => {
      requests.push(browsePanneaux(location.coordonnees, rayon, dateStart,
        dateEnd, proposableLc, codeFace));
    });
    const response = await Promise.all(requests);
    for (let i = 0; i < response.length; i += 1) {
      for (let j = 0; j < response[i].data.length; j += 1) {
        response[i].data.forEach(r => {
          r.pointAddress = locations[i];
        });
      }
    }
    return response;
  } catch (e) {
    throw e;
  }
}
export async function getFichePdf(ecranNumerique) {
  try {
    const response = await HTTP.post(`${PANNEAUX_NUMERIQUES_URL}/ficheEcranPdf`, ecranNumerique, { responseType: 'blob' });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getProduitFaceNumerique(id) {
  const response = await HTTP.get(PANNEAUX_NUMERIQUES_URL + '/produitFace/' + id);
  return response;
}



// WEBPACK FOOTER //
// ./src/api/panneauxNumeriques/index.js